import React, { useEffect } from "react";
import Loader from "../components/new/Loader";
import { Navigate, Outlet, useNavigation } from "react-router-dom";
import { isUserLoggedIn } from "../utility/utils";
import TopNavbar from "../pages/CounterPanel/components/TopNavbar";

export default function CounterLayout() {
    const navigation = useNavigation();
    if (!isUserLoggedIn()) return <Navigate to="/login" />;

    // useEffect(() => {
    //     // Set company name as browser tab title
    //     const user = getLocalUserInfo();
    //     if (user?.name) {
    //         document.title = user.name;
    //     }
    // }, []);

    return (
        <>
            <TopNavbar />
            <div className="px-3 py-2 max-lg:min-w-[930px]">
                {navigation.state === "loading" ? (
                    <div
                        className="relative"
                        style={{ height: "calc(100dvh - 133px)" }}
                    >
                        <Loader />
                    </div>
                ) : (
                    <Outlet />
                )}
            </div>
        </>
    );
}
